import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import ReportStore from 'stores/ReportStore'
import './Print.css';
import { momentHelper } from '../../report/helpers'

const DEFAULT_ROW = 15
class PrintReportAnalysisWorkCustomCost extends Component {

    constructor(...args) {
        super(...args)
        
        this.state = {loading:false,dataList:[],data:[],custom_cost_field:[],report_title:'กำลังดึงข้อมูล..',itemPerPage:DEFAULT_ROW}

        var cssPagedMedia = (function() {
            var style = document.createElement('style');
            document.head.appendChild(style);
            return function (rule) {
                style.innerHTML = rule;
            };
        }());
  
        cssPagedMedia.size = function(size) {
            cssPagedMedia('@page {size: ' + size + '}');
        };
        cssPagedMedia.size('landscape');
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        if (this.props.isRange==='false'&&this.props.year!==undefined&&this.props.month!==undefined&&this.props.day!==undefined) {
            ReportStore.loadAnalysisWorkCustomCost(this.props.year,this.props.month,this.props.day,(result)=>{
                this.setState({data:result.data,custom_cost_field:result.custom_cost_field,dataList:this.getPagination(result.data,this.state.itemPerPage),report_title:'ไม่พบข้อมูล'})
            },()=>{

            })   
        } else if (this.props.isRange==='true'&&this.props.startDate!==undefined&&this.props.endDate!==undefined) {
            ReportStore.loadAnalysisWorkCustomCostRange(this.props.startDate,this.props.endDate,(result)=>{
                this.setState({data:result.data,custom_cost_field:result.custom_cost_field,dataList:this.getPagination(result.data,this.state.itemPerPage),report_title:'ไม่พบข้อมูล'})
            },()=>{
                
            })
        } else {
            this.setState({data:[],custom_cost_field:[],dataList:this.getPagination([]),report_title:'ไม่พบข้อมูล'})
        }
    }

    getNumberFormat(value,digit=2) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(digit).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }

    getDate() {
        let {day,year,month,isRange,startDate,endDate} = this.props
        if (isRange==='true') {
            let start = startDate
            let end = endDate
            return 'ประจำวันที่ '+start+' - '+end
        } else {
            let text = 'ประจำวันที่ '
            text += day+' '+momentHelper.getMonthText(month)+' '+(year-543)
            if (year==='0'||year==='00'||year===0) {
                text = 'ทั้งหมด'
            } else if (month==='0'||month==='00'||month===0) {
                text = 'ประจำปี '+(year-543)
            } else if (day==='0'||day==='00'||day===0) {
                text = 'ประจำเดือน '+momentHelper.getMonthText(month)+' '+(year-543)
            }
            return text
        }  
    }

    renderRowData(data,indexs,field) {
        let {custom_cost_field,itemPerPage} = this.state
        if (data.length===0) {
            return(<tr><td colSpan={6}>ไม่พบข้อมูล</td></tr>)
        } else {
            return(
                data.map((item,index)=>{
                    let number = 1    
                    if (indexs===0)
                        number += index
                    else {
                        number += (indexs*itemPerPage)+index
                    }
                    return(
                        <tr key={index}>
                            <td className='text-center'>{number}</td>
                            <td className='text-center'>{item.work_no}</td>
                            <td className='text-center'>{item.brand}</td>
                            <td className='text-center'>{item.car_registration_no}</td>
                            <td className='text-center'>{item.insurer_name}</td>
                            <td className='text-center'>{item.vip_member}</td>
                            <td className='text-center'>{item.damage_major_quantity}</td>
                            <td className='text-center'>{item.damage_minor_quantity}</td>
                            <td className='text-right'>{this.getNumberFormat(item.approved_wage)}</td>
                            <td className='text-right'>{this.getNumberFormat(item.part_cost)}</td>
                            {custom_cost_field.map((sitem,sindex)=>{
                                return(
                                    <td className='text-right' key={index+'-'+sindex}>{this.getNumberFormat(item[sitem.field])}</td>
                                )
                            })}
                        </tr>
                    )
                })
            )
        }
    }

    renderTable(item,index,length) {
        let {custom_cost_field} = this.state
        return(
            <table className='table table-print-report-product-balance'>
                <tbody>
                    <tr>
                        <td colSpan={6}></td>
                        <td colSpan={2} className='text-center'>จำนวนชิ้นงาน</td>
                        <td colSpan={2} className='text-center'>ราคาที่ได้รับ</td>
                        <td colSpan={custom_cost_field.length} className='text-center'>ต้นทุน</td>
                    </tr>
                    <tr>
                        <td className='text-center' style={{width:'50px'}}>ลำดับ</td>
                        <td className='text-center' style={{width:'120px'}}>Job No.</td>
                        <td className='text-center' style={{width:'100px'}}>ยี่ห้อ</td>
                        <td className='text-center' style={{width:'110px'}}>ทะเบียน</td>
                        <td className='text-center' style={{width:'110px'}}>ประกัน</td>
                        <td className='text-center' style={{width:'110px'}}>Member</td>
                        <td className='text-center' style={{width:'90px'}}>ชิ้นหลัก</td>
                        <td className='text-center' style={{width:'90px'}}>ชิ้นรอง</td>
                        <td className='text-center' style={{width:'90px'}}>ค่าแรง</td>
                        <td className='text-center' style={{width:'90px'}}>ค่าอะไหล่</td>
                        {custom_cost_field.map((item,index)=>{
                            return(
                                <td key={index} className='text-center' style={{width:'90px'}}>{item.title}</td>
                            )
                        })}
                    </tr>
                    {this.renderRowData(item,index,length)}
                </tbody>
            </table>
        )
    }

    renderComponentPage(item,index,length) {
        return(  
            <div className='font-print print-report-analsis-inout-work' key={index}>
                <header className="text-center">
                    <h2>ตารางรายงานต้นทุน</h2>
                </header>
                <div>
                    {this.renderTable(item,index,length)}
                </div>
            </div>
        )    
    }
    
    renderNoData() {
        return(
          <div className='font-print'>
            <header className="text-center">
              <h2>{this.state.report_title}</h2>
            </header>
          </div>
        )
    }

    onRowsPerPageChange(itemPerPage) {
        this.setState({itemPerPage:itemPerPage},()=>{
            this.loadData()
        })
    }

    getPagination(data,itemPerPage) {
        let newData = []
        let allData = []
        let checkRow = 0
        data.forEach(function(item,index) {
            if (checkRow<itemPerPage+1)
              checkRow++
            newData.push(item)
    
            if (checkRow===itemPerPage||index===data.length-1) {
              allData.push(newData)
              checkRow = 0
              newData = []
            }
        })  
        
        return allData
    }

    render() {
        let {loading,dataList,itemPerPage} = this.state
        if (dataList.length===0) {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                    size='landscape'
                    startRowPerPage={5}
                    endRowPerPage={20}
                    defaultRowPerPage={itemPerPage}
                    onRowsPerPageChange={this.onRowsPerPageChange.bind(this)}
                >
                    {this.renderNoData()}    
                </PrintPreview>
            )
        } else {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                    size='landscape'
                    startRowPerPage={5}
                    endRowPerPage={20}
                    defaultRowPerPage={itemPerPage}
                    onRowsPerPageChange={this.onRowsPerPageChange.bind(this)}
                >
                    {
                        dataList.map((item,index)=>{
                            return(
                                this.renderComponentPage(item,index,dataList.length)
                            )
                        })   
                    }
                </PrintPreview>
            )
        }      
    }
}

PrintReportAnalysisWorkCustomCost.defaultProps = {
    title: 'ตารางรายงานต้นทุน',  
    mode: '',
    workNo: ''
}
export default PrintReportAnalysisWorkCustomCost;


// WEBPACK FOOTER //
// ./src/view/print/analysis/PrintReportAnalysisWorkCustomCost.js